import deDashboard from './dashboard/dashboard.json'
import deStats from './stats/stats.json'
import deAccreditation from './accreditation/accreditation.json'
import deCms from './cms/cms.json'
import deAuth from './auth/auth.json'
import deCommon from './common/common.json'
import deCompetition from './competition/competition.json'
import deGeneralApplications from './general-applications/general-applications.json'
import deLeague from './league/league.json'
import deMatch from './match/match.json'
import deNotification from './notification/notification.json'
import deOrganization from './organization/organization.json'
import dePhase from './phase/phase.json'
import deRecreation from './recreation/recreation.json'
import deRoles from './roles/roles.json'
import deSeason from './season/season.json'
import deShared from './shared/shared.json'
import deSponsor from './sponsor/sponsor.json'
import deSport from './sport/sport.json'
import deUnit from './unit/unit.json'
import deUser from './user/user.json'
import deUtils from './utils/utils.json'

export const de = {
    dashboard: deDashboard,
    stats: deStats,
    common: deCommon,
    competition: deCompetition,
    roles: deRoles,
    accreditation: deAccreditation,
    notification: deNotification,
    league: deLeague,
    sponsor: deSponsor,
    season: deSeason,
    unit: deUnit,
    user: deUser,
    organization: deOrganization,
    sport: deSport,
    shared: deShared,
    'general-applications': deGeneralApplications,
    utils: deUtils,
    phase: dePhase,
    auth: deAuth,
    match: deMatch,
    recreation: deRecreation,
    cms: deCms,
}
